import { User } from "./../models/user.model";
import { Component, OnInit } from "@angular/core";
import { UserService } from "../_services/user.service";
import Swal from "sweetalert2";
import { DomSanitizer } from "@angular/platform-browser";
@Component({
  selector: "app-user",
  templateUrl: "./user.component.html",
  styleUrls: ["./user.component.css"],
})
export class UserComponent implements OnInit {
  users: User[];
  avatar = "assets/img/avatars/user.png";
  constructor(
    private userService: UserService,
    public sanitizer: DomSanitizer
  ) {}

  ngOnInit() {
     ///////
     var pageHeader = $(".content-header").find("b");
     var adminForm = $(".admin-form");
     var buttons = adminForm.find(".button");
     var Panel = adminForm.find(".panel");
     setTimeout(function () {
       adminForm.addClass("theme-success");
       Panel.addClass("panel-success");
       pageHeader.addClass("text-success");

       buttons.removeClass().addClass("button btn-success");
     }, 800);
     //////
    this.loadUserTable();
  }
  loadUserTable() {
    this.userService.getAll().subscribe((data: User[]) => {
      this.users = [];
      for (let u of data) {
        for (let r of u.roles) {
          if (r.name != "ROLE_USER") {
            this.users.push(u);
            break;
          }
        }
      }
      //this.users = data;
      for (let u of this.users) {
        u.role = [];
        for (let r of u.roles) {
          if (r.name == "ROLE_ADMIN") {
            u.role.push("Admin");
          }
          if (r.name == "ROLE_MODERATOR") {
            u.role.push("Modérateur");
          }
        }
      }
    });
  }

  deleteUser(id) {
    Swal.fire({
      title: "Êtes-vous sûr de vouloir supprimer?",
      showCancelButton: true,
    }).then((result) => {
      if (result.value) {
        this.delete(id);
        // handle Confirm button click
        // result.value will contain `true` or the input value
      } else {
        // handle dismissals
        // result.dismiss can be 'cancel', 'overlay', 'esc' or 'timer'
      }
    });
  }

  delete(id) {
    this.userService.delete(id).subscribe(() => {
      this.loadUserTable();
    });
  }
}
